const NoDataCard = () => {
  return (
    <div className="flex flex-col w-full">
      <div className="h-[400px] bg-white flex items-center justify-center">
        <img className="img-1" src="/images/nodata.png" alt="" />
      </div>
      <div className="w-full h-auto">
        <img
          src="/images/line-bot.png"
          alt=""
          className="w-full h-auto object-contain hidden lg:block"
        />
        <img
          src="/images/line-open.png"
          alt=""
          className="w-full h-auto object-contain block lg:hidden"
        />
      </div>
    </div>
  );
};

export default NoDataCard;
